import round from "lodash/round";

export function formatNumberWithCommas(number) {
  if (!number) return "";
  const [integerPart, decimalPart] = number.toString().split(".");
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );
  return decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;
}

export function formatCurrencyWithCommas(
  numberArg,
  alwaysForceTwoDecimals = true
) {
  let number = alwaysForceTwoDecimals ? round(numberArg, 2) : numberArg;

  let formattedNumber = formatNumberWithCommas(number);
  const decimals = formattedNumber.split(".")[1];

  if (alwaysForceTwoDecimals && !decimals) formattedNumber += ".00";
  else if (decimals && decimals.length === 1) formattedNumber += "0";

  return formattedNumber;
}
